import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiTableRow(theme: Theme): MuiThemeComponentOverride<"MuiTableRow"> {
  return {
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: `${theme.palette.brand.orange[100].main}`,

            // eslint-disable-next-line sort-keys-fix/sort-keys-fix
            "&:hover": {
              backgroundColor: `${theme.palette.brand.orange[100].lighter}`,
            },
          },

          "&.MuiTableRow-hover": {
            "&:hover": {
              backgroundColor: `${theme.palette.brand.orange[100].lighter}`,
            },
          },
        },
      },
    },
  };
}
